module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || '2o7gtxly',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
